
import React, {Component} from 'react';


  
  class Home extends Component {
    render() {
      return (
        <div style={{marginTop: '22%', marginLeft: '5%', width: '60%', fontFamily: 'Optima'}}>
           <h1 style={{fontSize: '45px', color :'#b2dfdb'}}>
              Maurice Duits 
            </h1> 
           <h2 style={{fontSize: '45px',color :'#009688'}}> 
             Royal Institute of Technology 
          </h2> 
           <p style={{fontSize: '20px', color :'white'}}> 
              Hi, welcome to my webpage! I am a Professor at the Mathematics Department of the Royal Insitute of Technology (KTH). My research interest is in the interplay between Analysis, Probability and Mathematical Physics.
            </p>
      </div>
      );
    }
  }

  export default Home;